// 全部-筛选项
const allFormList = [
    { title: '订单编号', type: 'input', key: 'orderSn' },
    { title: '下单时间', type: 'daterange', key: ['startTime', 'endTime'] },
    { title: '商品品牌', type: 'input', key: 'brandName' },
    { title: '商品名称', type: 'input', key: 'productName' },
    { title: 'SKU名称', type: 'input', key: 'skuName' },
    { title: '门店信息', type: 'input', key: 'storeName', placeholder: '请输入门店名称/联系人/联系方式' },
    { title: '收件信息', type: 'input', key: 'keyword', placeholder: '请输入收件人姓名/联系方式/地址' },
    {
        title: '品牌商',
        type: 'select',
        key: 'brandingCompanyId',
        options: [],
        filterable: true,
    },
    {
        title: '购买方式',
        type: 'select',
        key: 'buyType',
        options: [
            { id: 0, name: '积分' },
            { id: 1, name: '现金' },
            { id: 2, name: '积分+现金' },
        ],
    },
    {
        title: '支付方式',
        type: 'select',
        key: 'payType',
        options: [
            { id: 7, name: '积分抵用' },
            { id: 1, name: '微信支付' },
            { id: 2, name: '支付宝支付' },
            { id: 0, name: '快捷支付' },
        ],
    },
    { title: '支付交易号', type: 'input', key: 'paySn' },
    {
        title: '退款状态',
        type: 'select',
        key: 'refundStatus',
        options: [
            { id: 0, name: '无退款' },
            { id: 1, name: '已部分退款' },
            { id: 2, name: '已全额退款' },
        ],
    },
    {
        title: '物流状态',
        type: 'select',
        key: 'logisticsStatus',
        options: [
            { id: 0, name: '未查询' },
            { id: 1, name: '运输中' },
            { id: 2, name: '已签收' },
            { id: 3, name: '无效订单' },
        ],
    },
    { title: '发货时间', type: 'daterange', key: ['sendStartTime', 'sendEndTime'] },
    { title: '物流单号', type: 'input', key: 'logisticsNo' },
    {
        title: '有效订单',
        type: 'select',
        key: 'effectiveOrder',
        options: [{ id: 'true', name: '是' }],
    },
];
// 全部-表头
const allColumns = [
    { title: '商品名称', key: 'productName', minWidth: 200, fixed: 'left' },
    { title: '商品规格', key: 'skuSpec', minWidth: 200 },
    { title: '订单编号', key: 'orderNo', minWidth: 200 },
    { title: '品牌', key: 'brandName', minWidth: 120 },
    { title: '单价(元)', key: 'amount', minWidth: 120 },
    { title: '数量', key: 'quantity', minWidth: 120 },
    { title: '单位', key: 'company', minWidth: 120 },
    {
        title: '订单总额',
        key: 'orderAmount',
        minWidth: 200,
        render: (h, p) => {
            return h('div', [
                h('p', `订单总额(元)：${p.row.orderAmount}`),
                p.row.deductionAmount > 0 && h('p', `积分抵用(积分)：${p.row.deductionAmount}`),
                p.row.netReceiptsAmount > 0 && h('p', `三方支付(元)：${p.row.netReceiptsAmount}`),
            ]);
        },
    },
    { title: '购买方式', key: 'buyTypeStr', minWidth: 120 },
    {
        title: '支付方式',
        key: 'payType',
        minWidth: 120,
        render: (h, p) => {
            return h('div', p.row.payType || '-');
        },
    },
    {
        title: '支付交易号',
        key: 'paySn',
        minWidth: 200,
        render: (h, p) => {
            return h('div', p.row.paySn || '-');
        },
    },
    { title: '门店名称', key: 'storeName', minWidth: 200 },
    { title: '注册手机号', key: 'ownerPhone', minWidth: 200 },
    { title: '收件人', key: 'personName', minWidth: 200 },
    { title: '收件号码', key: 'mobile', minWidth: 200 },
    { title: '收件人地址', key: 'detailAddress', minWidth: 200 },
    {
        title: '品牌商',
        key: 'brandingCompanyName',
        minWidth: 200,
        render: (h, p) => {
            let list = p.row.itemList
                .map((item) => {
                    return item.brandingCompanyName;
                })
                .join('、');
            return h('div', list);
        },
    },
    {
        title: '物流公司',
        key: 'logisticsCompany',
        minWidth: 200,
        render: (h, p) => {
            return h('div', p.row.logisticsCompany || '-');
        },
    },
    {
        title: '物流单号',
        key: 'logisticsNo',
        minWidth: 200,
        render: (h, p) => {
            return h('div', p.row.logisticsNo || '-');
        },
    },
    {
        title: '发货时间',
        key: 'sendDate',
        minWidth: 200,
        render: (h, p) => {
            return h('div', p.row.sendDate || '-');
        },
    },
    {
        title: '物流状态',
        key: 'logisticsStatus',
        minWidth: 120,
        render: (h, p) => {
            return h(
                'div',
                {
                    0: '未查询',
                    1: '运输中',
                    2: '已签收',
                    3: '无效订单',
                }[p.row.logisticsStatus] || '-',
            );
        },
    },
    { title: '下单时间', key: 'placeDate', minWidth: 200 },
    {
        title: '支付时间',
        key: 'payTime',
        minWidth: 200,
        render: (h, p) => {
            return h('div', p.row.payTime || '-');
        },
    },
    {
        title: '退款状态',
        key: 'refundStatusStr',
        minWidth: 120,
        render: (h, p) => {
            return h('div', p.row.refundStatusStr || '-');
        },
    },
    {
        title: '已退数量',
        key: 'refundCount',
        minWidth: 120,
        render: (h, p) => {
            return h('div', p.row.refundCount || '-');
        },
    },
    {
        title: '已退总额',
        minWidth: 200,
        render: (h, p) => {
            return h('div', [
                h('p', p.row.refundTotalAmount > 0 ? `已退总额(元)：${p.row.refundTotalAmount}` : '-'),
                p.row.refundScoreAmount > 0 && h('p', `积分退款(积分)：${p.row.refundScoreAmount}`),
                p.row.refundThirdAmount > 0 && h('p', `三方支付退款(元)：${p.row.refundThirdAmount}`),
            ]);
        },
    },
    {
        title: '订单状态',
        width: 120,
        render: (h, p) => {
            let badge = h('Badge', {
                props: {
                    color: {
                        1001: 'blue',
                        1002: 'green',
                        1003: 'red',
                        1004: 'blue',
                        1005: 'red',
                        1006: 'blue',
                    }[p.row.status],
                    text: {
                        1001: '待发货',
                        1002: '已发货',
                        1003: '已取消',
                        1004: '待付款',
                        1005: '已关闭',
                        1006: '已退款',
                    }[p.row.status],
                },
            });
            return h('div', [badge]);
        },
    },
];
// 待付款-筛选项
const pendpayFormList = allFormList.slice(0, 9);
// 待付款-表头
const pendpayColumns = allColumns;
// 待发货-筛选项
const waitFormList = allFormList.slice(0, 12);
// 待发货-表头
const waitColumns = allColumns.slice(0, 26);
// 已发货-筛选项
const sendFormList = allFormList.slice(0, 15);
// 已发货-表头
const sendColumns = allColumns.slice(0, 26);
// 已关闭-筛选项
const closeFormList = allFormList.slice(0, 9);
// 已闭-表头
const closeColumns = allColumns;
// 已取消-筛选项
const cancelFormList = allFormList.slice(0, 9);
// 已消-表头
const cancelColumns = allColumns;
// 已退款-筛选项
const refundFormList = [...allFormList.slice(0, 11), ...allFormList.slice(12, 15)];
// 已退款-表头
const refundColumns = allColumns.slice(0, 26);

export {
    allFormList,
    allColumns,
    pendpayFormList,
    pendpayColumns,
    waitFormList,
    waitColumns,
    sendFormList,
    sendColumns,
    closeFormList,
    closeColumns,
    cancelFormList,
    cancelColumns,
    refundFormList,
    refundColumns,
};
